import { Flex, theme } from '@/components';
import { AnalysisSearchKeys } from '@/features/search/_models/analysis-search';
import type { ProjectSearchKeys } from '@/features/search/_models/projects-search';
import type { ExtractKeyOf } from '@/utils/utils';
import type { FC } from 'react';
import { AccountingTypeIdsTag } from '../../_common/tags/AaccountingTypeIdsTag';
import { AccountingTypeTag } from '../../_common/tags/AccountingTypeTag';
import { CascaderFieldTag } from '../../_common/tags/CascaderFieldTag';
import { CategoriesTag } from '../../_common/tags/CategoriesTag';
import { ImplementationMethodsTag } from '../../_common/tags/ImplementationMethodsTag';
import { PaymentTag } from '../../_common/tags/PaymentTag';
import { PeriodTag } from '../../_common/tags/PeriodTag';
import { TextSearchTag } from '../../_common/tags/TextSearchTag';
import { CommonFilterTag } from './CommonFilterTag';

type FieldKey = (typeof ProjectSearchKeys)[number];

type HiddenFieldKey = ExtractKeyOf<
  FieldKey,
  | 'nestedOtherResponsibleOrganizationIds'
  | 'nestedPolicyIds'
  | 'nestedExpenditureBudgetPurposeIds'
  | 'nestedOrganizationIds'
>;

const cascaderFildsKeys: HiddenFieldKey[] = [
  'nestedOrganizationIds',
  'nestedPolicyIds',
  'nestedOtherResponsibleOrganizationIds',
  'nestedExpenditureBudgetPurposeIds',
];

export const AnalysisSearchSearchFieldTags: FC<{
  onResetPayment: () => void;
}> = ({ onResetPayment }) => {
  const { token } = theme.useToken();
  return (
    <Flex vertical gap={8} wrap="wrap">
      <Flex
        gap={8}
        style={{ background: token.colorBgLayout, padding: 5 }}
        wrap="wrap"
      >
        {AnalysisSearchKeys.map((field) => {
          switch (field) {
            case 'q':
              return <TextSearchTag key={field} />;
            case 'corporateNumber':
              return <PaymentTag key={field} onResetPayment={onResetPayment} />;
            case 'categories':
              return <CategoriesTag key={field} />;
            case 'implementationMethods':
              return <ImplementationMethodsTag key={field} />;
            case 'accountingType':
              return <AccountingTypeTag key={field} />;
            case 'accountingTypeIds':
              return <AccountingTypeIdsTag key={field} />;
            case 'period':
              return <PeriodTag key={field} />;
            default:
              return <CommonFilterTag key={field} field={field} />;
          }
        })}
      </Flex>
      {cascaderFildsKeys.map((field) => (
        <CascaderFieldTag key={field} field={field} />
      ))}
    </Flex>
  );
};
